import { createFileRoute } from '@tanstack/react-router';
import { validateSearch } from '../../../utils/pagination';
import { IconInvoice, IconPlus } from '@maia/icons';
import { ButtonLink, PageHeader } from '@maia/ui';
import { getQuotationsOptions } from '../../../features/quotation/quotations/queryOptions';
import { QuotationsTable } from '../../../features/quotation/quotations/table';
import { mapInitialFilters } from '../../../utils/filter/utils';

export const Route = createFileRoute('/_authenticated/quotations/')({
  component: Page,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps: search }) =>
    queryClient.ensureQueryData(
      getQuotationsOptions(mapInitialFilters(search)),
    ),
  validateSearch: validateSearch,
});

export function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="layout-simple">
      <PageHeader
        className="area-page-header"
        icon={IconInvoice}
        title="Offertes"
        actions={
          <ButtonLink
            to="/add-insurance"
            intent="cta"
            size="default"
            iconLeft={IconPlus}
          >
            Nieuwe offerte
          </ButtonLink>
        }
      />
      <div className="area-page-content content-grid">
        <div className="col-span-full flex items-center justify-between">
          <QuotationsTable quotations={data} />
        </div>
      </div>
    </div>
  );
}
